<template>
  <div class="" v-if="storedivdetails">
    <b-row>
      <div class="d-flex mt-3">
        <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol" />
        <h6 class="bold-heading mt6 ms-1">{{ t("StoreDetails.title") }}</h6>
      </div>
    </b-row>

    <b-row class="my-2 ps-3">
      <b-col sm="12" md="12" lg="12" xl="10">
        <b-row>
          <b-col xxl="4" xl="4" lg="4" md="5" sm="5" cols="12" class="form-field-column">
            <label class="display-field-label">{{ t("StoreDetails.inventorymanage") }}</label>
          </b-col>
          <b-col xxl="8" xl="8" lg="8" md="7" sm="7" cols="12" class="form-field-column">
            <p class="details-black-field">
              {{
                storedivdetails && storedivdetails[0]
                  ? storedivdetails[0].ManagedBy == 1
                    ? "Hospital"
                    : "Branch"
                  : ""
              }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
            <label class="display-field-label">{{ t("StoreDetails.ms") }}</label>
          </b-col>
          <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
            <div class="details-color-card">
              <p class="details-black-field">{{ storemaindetails }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
            <label class="display-field-label">{{ t("StoreDetails.Store") }}</label>
          </b-col>
          <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
            <div class="store-badges">
              <div v-if="storesubdetails && storesubdetails.length > 0" class="store-badge ss-badge"
                @click="showStoreList('SS')">
                <span class="badge-label">SS</span>
                <span class="badge-count">{{ storesubdetails.length }}</span>
              </div>
              <div v-if="storedepdetails && storedepdetails.length > 0" class="store-badge ds-badge"
                @click="showStoreList('DS')">
                <span class="badge-label">DS</span>
                <span class="badge-count">{{ storedepdetails.length }}</span>
              </div>
              <div v-if="Object.keys(storesubdepdetails) && Object.keys(storesubdepdetails).length > 0"
                class="store-badge sds-badge" @click="showStoreList('SDS')">
                <span class="badge-label">SDS</span>
                <span class="badge-count">{{ Object.keys(storesubdepdetails).length }}</span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
            <h6 class="display-field-label">
              {{ t("StoreDetails.description") }}
            </h6>
          </b-col>
          <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
            <p class="details-description details-black-field">
              {{ storedivdetails && storedivdetails[0] ? storedivdetails[0].Remarks : "" }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>

  <div class="card">
    <Dialog v-model:visible="showDialog" :header="dialogHeader" :modal="true" :closable="true" :dismissableMask="true"
      :style="{ width: '50vw' }" class="p-fluid">
      <div class="table-width-80">
        <DataTable v-if="selectedStoreList.length > 0" :value="selectedStoreList" :paginator="true" :rows="10"
          :rowHover="true" class="p-datatable-gridlines" :filters="filters" :globalFilterFields="globalFilterFields"
          responsiveLayout="scroll" :loading="loading" @row-click="onRowClick">
          <Column v-for="col in tableHeaders" :key="col.field" :field="col.field" :header="col.header" :sortable="true"
            :class="col.class" />
        </DataTable>
      </div>
    </Dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, computed } from "vue";
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { useI18n } from 'vue-i18n';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from "primevue/usetoast";

const toast = useToast();
const { t } = useI18n();

interface StoreListItem {
  RowNumber: number;
  Name: string;
}

interface StoreDetails {
  ManagedBy: number;
  MainStoreName: string[];
  SubStoreName: string[];
  DepStoreName: string[];
  SubDepStoreName: string[];
  Remarks: string;
}

interface StoreDetailsProps {
  storedivdetails: {
    [index: number]: StoreDetails;
    length: number;
  };
}

const props = defineProps<StoreDetailsProps>();

const storemaindetails = ref<string>('');
const storesubdetails = ref<string[]>([]);
const storedepdetails = ref<string[]>([]);
const storesubdepdetails = ref<string[]>([]);

// Dialog related refs
const showDialog = ref(false);
const dialogHeader = ref('');
const selectedStoreList = ref<StoreListItem[]>([]);
const loading = ref(false);
let selectedType = ref('')

// Table configuration
const tableHeaders = computed(() => [
  {
    header: 'S.No',
    field: 'RowNumber',
    class: 'filterdisplaynone',
  },
  {
    header: 'Store Name',
    field: 'Name',
    class: 'mediumwidth',
  },
  {
    header: 'Department Name',
    field: 'DepName',
    class: selectedType.value == 'SDS' ? "mediumwidth" : "d-none mediumwidth",
  }

]);
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
});

const globalFilterFields = ['Name'];

const onRowClick = (event: any) => {
  console.log('Row clicked:', event.data);
};

// Function to show store list dialog
const showStoreList = (type: string) => {
  debugger
  console.log('Opening dialog for type:', type);
  loading.value = true;

  try {

    selectedType.value = type
    if (type === 'SS') {
      console.log('Sub Store List:', storesubdetails.value);
      dialogHeader.value = 'Sub Store List';
      if (storesubdetails.value.length === 0) {
        toast.add({ severity: 'info', summary: 'Info', detail: 'No sub stores available' });
        return;
      }
      selectedStoreList.value = storesubdetails.value.map((name, index) => ({
        RowNumber: index + 1,
        Name: name
      }));
    }
    else if (type === 'SDS') {
      dialogHeader.value = 'SubDepartment Store List';
      debugger
      selectedStoreList.value = Object.entries(storesubdepdetails.value).map(([mainName, subNames], index) => ({
        RowNumber: index + 1,
        Name: mainName,
        DepName: Array.isArray(subNames) ? subNames.join(", ") : subNames
      }));
      debugger
    }

    else {
      console.log('Department Store List:', storedepdetails.value);
      dialogHeader.value = 'Department Store List';
      if (storedepdetails.value.length === 0) {
        toast.add({ severity: 'info', summary: 'Info', detail: 'No department stores available' });
        return;
      }
      selectedStoreList.value = storedepdetails.value.map((name, index) => ({
        RowNumber: index + 1,
        Name: name
      }));
    }
    console.log('Selected Store List:', selectedStoreList.value);
    showDialog.value = true;
  } catch (error) {
    console.error('Error showing store list:', error);
    toast.add({ severity: 'error', summary: 'Error', detail: 'Error loading store list' });
  } finally {
    loading.value = false;
  }
};

const validateAndProcessStoreData = (data: any[], type: string): string[] => {
  if (!Array.isArray(data)) {
    console.warn(`${type} is not an array:`, data);
    return [];
  }

  // Filter out any non-string or empty values
  const validData = data.filter(item => typeof item === 'string' && item.trim() !== '');

  if (validData.length !== data.length) {
    console.warn(`Some ${type} items were invalid and filtered out`);
  }

  return validData;
};

const updateStoreDetails = () => {
  console.log('Raw props:', props);

  if (!props.storedivdetails || !props.storedivdetails[0]) {
    console.warn('No store details provided or invalid structure');
    return;
  }

  try {
    const storeData = props.storedivdetails[0];
    console.log('Store data:', storeData);

    // Process main store details
    const validMainStores = validateAndProcessStoreData(storeData.MainStoreName || [], 'MainStoreName');
    storemaindetails.value = validMainStores.join(', ');
    console.log('Processed Main Store Details:', storemaindetails.value);

    // Process sub store details
    const validSubStores = validateAndProcessStoreData(storeData.SubStoreName || [], 'SubStoreName');
    storesubdetails.value = validSubStores;
    console.log('Processed Sub Store Details:', {
      count: storesubdetails.value.length,
      list: storesubdetails.value
    });

    // Process department store details
    const validDeptStores = validateAndProcessStoreData(storeData.DepStoreName || [], 'DepStoreName');
    storedepdetails.value = validDeptStores;
    debugger
    const validSubDeptStores = storeData.SubDepStoreName || []
    storesubdepdetails.value = validSubDeptStores;
    console.log('Processed Dept Store Details:', {
      count: storedepdetails.value.length,
      list: storedepdetails.value
    });

    // Log final state for verification
    console.log('Final Store State:', {
      main: storemaindetails.value,
      sub: storesubdetails.value,
      dept: storedepdetails.value
    });

  } catch (error) {
    console.error('Error updating store details:', error);
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Error processing store details. Please check console for details.'
    });
  }
};

onMounted(() => {
  console.log('Component mounted, initial store details:', props.storedivdetails);
  updateStoreDetails();
});

watch(() => props.storedivdetails, (newValue) => {
  console.log('Store details changed:', newValue);
  updateStoreDetails();
});
</script>

<style lang="scss" scoped>
.details-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.store-badges {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 4px;
}

.store-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 15px;
  border-radius: 100px;
  cursor: pointer;
  min-width: 90px;
  justify-content: flex-start;
  height: 28px;

  .badge-label {
    font-size: 13px;
    font-weight: 500;
    margin-right: 20px;
    min-width: 20px;
    text-align: center;
  }

  .badge-count {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }

  &.ss-badge {
    background-color: #FFF8F2;

    .badge-label {
      color: #FF9F43;
    }
  }

  &.ds-badge {
    background-color: #FFF2F4;

    .badge-label {
      color: #FF5C75;
    }
  }

  &.sds-badge {
    background-color: #FFF8F2;

    .badge-label {
      color: #FF9F43;
    }
  }
}

:deep(.p-dialog-header) {
  padding: 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eee;
}

:deep(.p-dialog-content) {
  padding: 1.25rem;
}

.table-width-80 {
  width: 100%;
  margin: 0 auto;
}

:deep(.p-datatable) {
  .p-datatable-tbody>tr {
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f8f9fa;
    }
  }

  .p-column-header-content {
    font-weight: 600;
  }
}

.details-black-field {
  font-size: 14px;
  color: #333333;
  margin-bottom: 0;
}

.display-field-label {
  font-size: 14px;
  color: #666666;
  margin-bottom: 0;
}
</style>
